import { render, staticRenderFns } from "./Conter.vue?vue&type=template&id=01fc8ba2&scoped=true&"
import script from "./Conter.vue?vue&type=script&lang=js&"
export * from "./Conter.vue?vue&type=script&lang=js&"
import style0 from "./Conter.vue?vue&type=style&index=0&id=01fc8ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc8ba2",
  null
  
)

export default component.exports